module.exports = __webpack_public_path__ + "static/img/platform-group4.598cba9a.png";